import "./RoboticsCourseD4.module.css";
import Header from "@/reusable_sections/Header";
import RoboticsDetail from "./sections/RoboticsDetail";
import Footer from "@/reusable_sections/Footer";
export default function RoboticsCourseD4Page() {
  return <div>
      <Header />
      <RoboticsDetail />
      <Footer />
    </div>;
}